<script setup lang="ts">
import { BTabs } from '@/design-system';
import { useTranslation } from '@/composables';
import { computed, onMounted } from 'vue';

type PropsType = {
    color?: string;
    density?: 'comfortable' | 'compact';
    grow?: boolean;
    vertical?: boolean;
    tabsContentClasses?: string;
    validation?: boolean;
};

withDefaults(defineProps<PropsType>(), {
    color: 'primary',
    density: 'comfortable',
    grow: false,
    vertical: false,
    validation: false,
});

const activeCurrency = defineModel<string>('modelValue', { default: 'USD' });
const { getCurrencies, fetchCurrencies } = useTranslation();

const currencyTabs = computed(() =>
    getCurrencies().map(currency => ({
        id: currency.value,
        title: currency.name,
    })),
);

onMounted(async () => {
    await fetchCurrencies();
});
</script>

<template>
    <BTabs
        v-model="activeCurrency"
        :tabs="currencyTabs"
        :color="color"
        :density="density"
        :grow="grow"
        :vertical="vertical"
        :tabs-content-classes="tabsContentClasses"
        :validation="validation"
    >
        <template
            v-for="currency in getCurrencies()"
            :key="currency.value"
            #[currency.value]="{ tab, active }"
        >
            <slot
                :name="currency.value"
                :currency="currency"
                :tab="tab"
                :active="active"
            />
        </template>

        <template
            v-if="$slots.append"
            #append
        >
            <slot name="append" />
        </template>
    </BTabs>
</template>
